import { createFileRoute } from "@tanstack/react-router";
import AdminLogoAudit from "@/pages/AdminLogoAudit";

export const Route = createFileRoute("/admin/logo-audit/")({
  component: AdminLogoAudit,
});
